(function () {
  'use strict';

  var PRIZES = {
    1: { label: '1等', name: 'Loop Tower（ホワイト）', color: '#a2443c', type: 'goods' },
    2: { label: '2等', name: 'CHILLAX', color: '#8f6b37', type: 'goods' },
    3: { label: '3等', name: 'Locus', color: '#5b7182', type: 'goods' },
    4: { label: '4等', name: 'Cylinder', color: '#5f7464', type: 'goods' },
    5: { label: '5等', name: '猫用トイレ', color: '#756379', type: 'goods' },
    6: { label: '6等', name: '1,000円クーポン', color: '#7c5d4c', type: 'coupon' }
  };

  // TEST MODE ONLY: 1%, 1%, 2%, 3%, 20%, 73%.
  // Production odds/remaining quantities must be decided server-side.
  var TEST_WEIGHTS = [1, 1, 2, 3, 20, 73];

  // NO browser clock for official campaign status. Supabase returns the phase.
  // Local test mode is only a visual animation demo, never a real draw.

  function makeTestCode() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var code = 'MZ';
    for (var i = 0; i < 4; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }

  function weightedTestRank() {
    var total = TEST_WEIGHTS.reduce(function (a, b) { return a + b; }, 0);
    var n = Math.random() * total;
    for (var i = 0; i < TEST_WEIGHTS.length; i++) {
      n -= TEST_WEIGHTS[i];
      if (n < 0) return i + 1;
    }
    return 6;
  }

  function testDraw(testResult, customerId) {
    var rank = testResult && testResult !== 'random' ? parseInt(testResult, 10) : weightedTestRank();
    return { rank: rank, code: rank === 6 ? makeTestCode() : '' };
  }

  function normalizeResult(data) {
    if (!data) return null;
    var rank = Number(data.rank || String(data.prizeKey || '').replace(/^p/, ''));
    if (!rank || !PRIZES[rank]) return null;
    return { rank: rank, code: data.code ? String(data.code) : '' };
  }

  function init(root) {
    if (!root || root.dataset.nygReady === '1') return;
    root.dataset.nygReady = '1';

    var gp = root.querySelector('myzoo-garapon');
    var replayWrap = root.querySelector('[data-nyg-replay-wrap]');
    var replayBtn = root.querySelector('[data-nyg-replay]');
    var announcement = root.querySelector('[data-nyg-announcement]');
    var machine = root.querySelector('[data-nyg-machine]');
    var phaseTitle = root.querySelector('[data-nyg-phase-title]');
    var phaseLead = root.querySelector('[data-nyg-phase-lead]');
    var phaseFoot = root.querySelector('[data-nyg-phase-foot]');
    if (!gp) return;

    // 【獎品圖片】1～5 等讀取 Shopify 商品首圖，6 等讀取圖片庫選取的圖片。
    // Shopify image_url 通常為 //cdn.shopify.com/...（不含 https:），舊版因此被略過。
    // 統一轉為完整 HTTPS 網址；不讓不安全的網址被載入。
    for (var prizeRank = 1; prizeRank <= 6; prizeRank++) {
      var imageUrl = (root.getAttribute('data-prize-image-' + prizeRank) || '').trim();
      if (!imageUrl) continue;
      try {
        var normalizedImageUrl = new URL(imageUrl, window.location.href);
        if (normalizedImageUrl.protocol === 'https:') {
          PRIZES[prizeRank].image = normalizedImageUrl.href;
        }
      } catch (error) {
        console.warn('[MYZOO garapon image] invalid prize URL for rank', prizeRank);
      }
    }

    var testMode = root.dataset.testMode === 'true';
    var testResult = root.dataset.testResult || 'random';
    var customerId = root.dataset.customerId || 'guest'; // UI hint only; backend always verifies Shopify signature
    var loginUrl = root.dataset.loginUrl || '/account/login';
    var savedResult = null;
    var replayMode = false;
    var localKey = 'myzoo-newyear-2027-result-' + customerId;

    function showAnnouncement(phase) {
      if (announcement) announcement.hidden = false;
      if (machine) machine.hidden = true;
      if (phase === 'ended') {
        if (phaseTitle) phaseTitle.textContent = 'イベントは終了しました';
        if (phaseLead) phaseLead.textContent = 'たくさんのご参加、誠にありがとうございました。';
        if (phaseFoot) phaseFoot.textContent = 'ご当選済みの方は、ログインすると抽選結果をご確認いただけます。';
      } else if (phase === 'loading') {
        if (phaseTitle) phaseTitle.textContent = 'イベント情報を確認しています';
        if (phaseLead) phaseLead.textContent = '少々お待ちください。';
        if (phaseFoot) phaseFoot.textContent = '';
      } else if (phase === 'error') {
        if (phaseTitle) phaseTitle.textContent = 'ただいま確認中です';
        if (phaseLead) phaseLead.textContent = '通信状況をご確認のうえ、少し時間をおいて再度お試しください。';
        if (phaseFoot) phaseFoot.textContent = '抽選結果は会員アカウントに記録されます。';
      } else {
        if (phaseTitle) phaseTitle.textContent = '元旦限定ガチャイベント';
        if (phaseLead) phaseLead.textContent = 'イベント開催まで、もうしばらくお待ちください。';
        if (phaseFoot) phaseFoot.textContent = '会員さま限定・お一人さま1回限り';
      }
    }

    function showMachine() {
      if (announcement) announcement.hidden = true;
      if (machine) machine.hidden = false;
    }

    showAnnouncement('loading');

    function backendUrl(path) {
      // Public campaign URL; no Instagram-only query parameter required.
      var u = new URL(path, window.location.origin);
      return u.pathname + u.search;
    }

    function showReplayButton() {
      if (replayWrap) replayWrap.hidden = !savedResult;
    }

    function setSavedResult(result) {
      var normalized = normalizeResult(result);
      if (!normalized) return;
      savedResult = normalized;
      showReplayButton();
      if (testMode) {
        try { localStorage.setItem(localKey, JSON.stringify(savedResult)); } catch (_) {}
      }
    }

    customElements.whenDefined('myzoo-garapon').then(function () {
      gp.prizes = PRIZES;
      gp.texts = {
        turnsLeft: 'あと{n}周',
        almost: 'もう少し！',
        hintStart: '赤い持ち手をつかんで、円を描くように回してください',
        hintGoing: 'その調子です。手を止めずに回しましょう',
        drawing: '玉が出ます',
        drawingSub: 'そのままお待ちください',
        doneTitle: '抽選済みです',
        doneSub: '賞品は初回の抽選結果で確定しています。',
        showResult: '抽選結果を見る',
        errorTitle: 'うまく抽選できませんでした',
        errorSub: '通信状況をご確認のうえ、もう一度ハンドルを回してください',
        congrats: 'おめでとうございます',
        goodsText: '当選おめでとうございます！当選内容はMYZOO側で記録しています。担当者より後日メールにてご連絡します。',
        goodsNote: '',
        couponLabel: 'あなた専用のクーポンコード',
        couponText: 'お買い物の際、決済画面でこのコードを入力してください。お一人さま1回限り使えます。',
        couponNote: '',
        copy: 'コードをコピー',
        copied: 'コピーしました',
        copySelected: '選択しました。長押しでコピーできます',
        close: '閉じる',
        soundOn: '音あり',
        soundOff: '音なし',
        lockedDefault: '会員ログインすると、ハンドルを回せるようになります。',
        handleLabel: 'ガラポンのハンドル。つかんで円を描くように回してください'
      };

      if (testMode) { showMachine(); gp.removeAttribute('state'); }
      else gp.setAttribute('state', 'locked'); // Unlock only when server confirms verified customer identity

      gp.drawHandler = function () {
        // Replay never calls the draw endpoint again. It only replays the first saved result.
        if (replayMode && savedResult) return Promise.resolve(savedResult);

        if (testMode) {
          if (savedResult) return Promise.resolve(savedResult);
          return Promise.resolve(testDraw(testResult, customerId));
        }

        return fetch(backendUrl('/apps/myzoo-gacha/draw'), {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ campaign: 'myzoo-newyear-2027' })
        }).then(function (res) {
          if (!res.ok) throw new Error('draw failed: ' + res.status);
          return res.json();
        }).then(function (data) {
          var result = normalizeResult(data);
          if (!result) throw new Error('invalid draw result');
          return result;
        });
      };

      gp.addEventListener('garapon:locked', function () {
        window.location.href = loginUrl;
      });

      gp.addEventListener('garapon:result', function (event) {
        setSavedResult(event.detail || gp.result);
        replayMode = false;
      });

      if (replayBtn) {
        replayBtn.addEventListener('click', function () {
          if (!savedResult) return;
          replayMode = true;
          gp.reset();
          gp.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      if (testMode) {
        try {
          var local = normalizeResult(JSON.parse(localStorage.getItem(localKey) || 'null'));
          if (local) {
            setSavedResult(local);
            gp.showDrawn(local);
          }
        } catch (_) {}
        return;
      }

      // Never trust phone/PC clock. Phase comes exclusively from the signed Shopify proxy.
      var refreshBusy = false;
      function refreshStatus(){
        if(refreshBusy || savedResult) return;
        refreshBusy = true;
        fetch(backendUrl('/apps/myzoo-gacha/status?campaign=myzoo-newyear-2027'), {
          method: 'GET', headers: { 'Accept': 'application/json' },
          credentials: 'same-origin', cache: 'no-store'
        }).then(function (res) {
          return res.json().catch(function () { throw new Error('INVALID_STATUS_RESPONSE'); });
        }).then(function (status) {
          var phase = status && status.phase;
          if (!['upcoming','open','ended'].includes(phase)) { showAnnouncement('error'); gp.setAttribute('state','locked'); return; }
          if (status.drawn) {
            var result = normalizeResult(status.result || status);
            if (!result) { showAnnouncement('error'); return; }
            setSavedResult(result);
            showMachine();
            gp.removeAttribute('state');
            gp.showDrawn(result);
            return;
          }
          if (status.eligible && (phase === 'open' || status.rehearsal === true)) {
            showMachine(); gp.removeAttribute('state'); return;
          }
          if (phase === 'open' && status.error === 'LOGIN_REQUIRED') {
            showMachine(); gp.setAttribute('state','locked'); return;
          }
          gp.setAttribute('state','locked');
          showAnnouncement(phase);
        }).catch(function (err) {
          gp.setAttribute('state','locked'); showAnnouncement('error');
          console.warn('[MYZOO garapon status]', err);
        }).finally(function(){refreshBusy=false;});
      }
      refreshStatus();
      // Refresh signed server state across JST midnight; no local device-clock decision.
      setInterval(refreshStatus, 30000);

    });
  }

  function boot(scope) {
    var base = scope || document;
    base.querySelectorAll('[data-nyg-garapon]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
